var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 117,
    viewBox: "0 0 118 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 107.25C85.8125 107.25 107.75 85.3125 107.75 58.5C107.75 31.6875 85.8125 9.75 59 9.75C32.1875 9.75 10.25 31.6875 10.25 58.5C10.25 85.3125 32.1875 107.25 59 107.25Z",
    fill: "#07B463",
    stroke: "#E6F8EF",
    strokeWidth: 5.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 58.4999L52.0775 72.2961L79.7188 44.7036",
    stroke: "#E6F8EF",
    strokeWidth: 5.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommended);
export default __webpack_public_path__ + "static/media/recommended.6dbced13b2343a079fb2a0469f6a665c.svg";
export { ForwardRef as ReactComponent };